export var ThemePreference;
(function (ThemePreference) {
    ThemePreference["LIGHT"] = "LIGHT";
    ThemePreference["DARK"] = "DARK";
    /**
     * Defer to the user's OS-configured preference, e.g. via prefers-color-scheme
     */
    ThemePreference["OS"] = "OS";
})(ThemePreference || (ThemePreference = {}));
